import * as React from "react";
const SvgFiRrUserCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-check_svg__a)">
      <path
        fill="#062147"
        d="M8 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6M8 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m8 20v1a1 1 0 0 1-2 0v-1c0-3.309-2.691-6-6-6s-6 2.691-6 6v1a1 1 0 0 1-2 0v-1c0-4.411 3.589-8 8-8s8 3.589 8 8m7.697-11.783-3.992 3.875a3.1 3.1 0 0 1-2.205.907 3.11 3.11 0 0 1-2.215-.917l-1.971-1.854a1 1 0 1 1 1.372-1.456l1.992 1.875c.471.47 1.195.449 1.623.021l4.002-3.886a1 1 0 1 1 1.393 1.435z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserCheck;
